import { useAtomValue } from "jotai";
import { useRef } from "react";
import { surveyCurrentStepAtom } from "../stores/survey-store";

export function useSurveyPercentage() {
  const currentStep = useAtomValue(surveyCurrentStepAtom);
  const currentPercentage = currentStep.body.progressPercentage;
  const previousPercentageRef = useRef<number>(currentPercentage);

  const previousPercentage = previousPercentageRef.current;

  if (currentPercentage !== previousPercentage) {
    previousPercentageRef.current = currentPercentage;
  }

  return {
    progressPercentage: currentPercentage,
    previousPercentage: previousPercentage,
  };
}
